export default {
  md: '0px 4px 6px rgba(0, 0, 0, 0.2)',
  lg: '0px 10px 20px rgba(0, 0, 0, 0.25)',
  inset: 'inset 0px 2px 6px rgba(0, 0, 0, 0.3)',
  radial: '0px 8px 24px rgba(0, 0, 0, 0.25)',
};
